import { baseDefaultContextProps } from '../../constants/props';
import { createCrmObjectBatch, createObject, searchObject } from '../../data/api/crmV3Api';
import { calculatePropertiesRequest, fetchCardProperties, fetchExternalOptions, fetchObjectCreationFields, fetchPropertiesDetails, getCreatorAssociationPropertiesDefinitions, getDealAmountSettings, getMultiCurrencies, validateProperty } from '../../data/api/propertiesApi';
import { fetchRenderedContent, fetchUnrenderedContent, searchSnippets } from '../../data/api/snippetsApi';
export const defaultAssociationModalContextProps = Object.assign({}, baseDefaultContextProps, {
  hubspotUserId: undefined,
  crmObjectType: 'contact',
  apiWrapper: {
    snippets: {
      fetchRenderedContent,
      fetchUnrenderedContent,
      searchSnippets
    },
    calculateProperties: calculatePropertiesRequest,
    getMultiCurrencies,
    getDealAmountSettings,
    fetchObjectCreationFields,
    fetchPropertiesDetails,
    createCrmObject: createObject,
    createCrmObjectBatch,
    validateProperty,
    getCreatorAssociationPropertiesDefinitions,
    fetchExternalOptions,
    searchObject,
    fetchCardProperties
  },
  newContactEmail: '',
  isContactsPage: false,
  createObjectCallback: undefined,
  lineItemsFeatureUnavailableComponent: undefined,
  showModal: false,
  closeModal: () => undefined,
  prosemirrorTrackerProperties: undefined
});